import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Plus: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[20px] h-[20px] stroke-[1.6px]', className)}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 3.5C10.8682 3.5 11.1667 3.79848 11.1667 4.16667V9.33333H16.3333C16.7015 9.33333 17 9.63181 17 10C17 10.3682 16.7015 10.6667 16.3333 10.6667H11.1667V15.8333C11.1667 16.2015 10.8682 16.5 10.5 16.5C10.1318 16.5 9.83333 16.2015 9.83333 15.8333V10.6667H4.66667C4.29848 10.6667 4 10.3682 4 10C4 9.63181 4.29848 9.33333 4.66667 9.33333H9.83333V4.16667C9.83333 3.79848 10.1318 3.5 10.5 3.5Z"
      fill="currentColor"
      strokeWidth="currentStrokWidth"
    />
  </svg>
);

export default Plus;
